import type { SvgJob } from "../../lib/types";
import { getStatusLabel, statusTone } from "./status";

export function JobStatusBadge({ job }: { job: Pick<SvgJob, "status"> }) {
  return <span className={`status-badge tone-${statusTone(job)}`}><span className="status-badge-dot" />{getStatusLabel(job)}</span>;
}
